import { statements } from "@/mocks/chigua";
import SectionHead from "./SectionHead";
import Reveal from "@/components/feature/Reveal";

const toneMap: Record<string, string> = {
  '紧急': 'bg-primary-100 text-primary-800',
  '严肃': 'bg-secondary-100 text-secondary-900',
  '一般': 'bg-background-200 text-foreground-700',
};

const iconMap: Record<string, string> = {
  '郑重声明': 'ri-shield-star-line',
  '辟谣说明': 'ri-aliens-line',
  '合规说明': 'ri-file-shield-2-line',
  '维权声明': 'ri-scales-3-line',
};

export default function Statements() {
  return (
    <section id="statements" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionHead
            kicker="官方声明 · STATEMENTS"
            title="吃瓜官网正式声明"
            subtitle="针对不实传闻、合规事项与合法权益的官方表态,信息准确、来源可溯,请以官网为准。"
            more="更多声明"
            moreHref="#statements"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {statements.map((s, idx) => (
            <Reveal key={s.id} delay={(idx % 2) * 80}>
              <article className="group relative h-full overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-200 md:p-6">
                <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-primary-500 to-accent-500"></div>
                <div className="flex flex-wrap items-center justify-between gap-2 pl-3">
                  <div className="flex items-center gap-3">
                    <span className={`flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-600`}>
                      <i className={iconMap[s.category] || 'ri-shield-star-line'}></i>
                    </span>
                    <div>
                      <div className="flex items-center gap-2">
                        <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{s.category}</h3>
                        <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${toneMap[s.tone]}`}>
                          {s.tone}
                        </span>
                      </div>
                      <span className="font-label text-xs text-foreground-400">发布于 {s.date}</span>
                    </div>
                  </div>
                  <i className="ri-quote-text text-3xl text-background-200"></i>
                </div>

                <h4 className="mt-4 pl-3 text-base font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-lg">
                  {s.title}
                </h4>
                <p className="mt-3 pl-3 text-sm leading-relaxed text-foreground-600">{s.body}</p>

                <div className="mt-4 flex items-center justify-between pl-3">
                  <span className="text-xs text-foreground-400">以上内容真实有效,保留最终解释权</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600">
                    查看原文
                    <i className="ri-external-link-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}